import { useContext } from "react";
import { Col, Form, Row } from "react-bootstrap";

import createOrderContext, { Trapvorm } from "../../context/createOrder/";
import { SelectChange } from "../../types/authTypes";
import {
  OrderType,
  orderTypes,
  ProfileColor,
  profileColors,
} from "../../types/orderTypes";

const BREEDTES = [100, 120, 140];

const TRAPVORMEN: { waarde: Trapvorm; label: string }[] = [
  { waarde: "recht", label: "Recht" },
  { waarde: "draai", label: "Draai" },
  { waarde: "dubbelkwart", label: "Dubbelkwart" },
];

/**
 * Type, profielkleur, breedte en trapvorm.
 *
 * Alle keuzelijsten tonen de waarde uit de state. Voorheen waren ze
 * ongecontroleerd en toonde de profielkleur "Zwart" terwijl er met
 * "Aluminium" werd gerekend.
 *
 * Een draai of dubbelkwart kan alleen bij 100 cm; bij een andere breedte gaat
 * de trapvorm terug naar "recht" (de backend weigert de combinatie ook).
 */
const StairsType = () => {
  const { type, profileColor, breedte, trapvorm } = useContext(createOrderContext);

  return (
    <div>
      <Row>
        <Form.Group as={Col} xs={6}>
          <Form.Label>Type trap</Form.Label>

          <select
            className="select"
            style={{ padding: "8px 4px", position: "inherit" }}
            value={type.value}
            onChange={(event: SelectChange) => {
              type.set(event.target.value as OrderType);
            }}
          >
            {orderTypes.map((item: any) => (
              <option value={item} key={item} className="select-item">
                {item}
              </option>
            ))}
          </select>
        </Form.Group>

        <Form.Group as={Col} xs={6}>
          <Form.Label>Kleur veiligheidsprofiel</Form.Label>

          <select
            className="select"
            style={{ padding: "8px 4px", position: "inherit" }}
            value={profileColor.value}
            onChange={(event: SelectChange) => {
              profileColor.set(event.target.value as ProfileColor);
            }}
          >
            {profileColors.map((item: any) => (
              <option value={item} key={item} className="select-item">
                {item}
              </option>
            ))}
          </select>
        </Form.Group>
      </Row>

      <Row className="mt-2">
        <Form.Group as={Col} xs={6}>
          <Form.Label>Breedte</Form.Label>

          <select
            className="select"
            style={{ padding: "8px 4px", position: "inherit" }}
            value={breedte.value}
            onChange={(event: SelectChange) => {
              const nieuw = Number(event.target.value);
              breedte.set(nieuw);
              if (nieuw !== 100) trapvorm.set("recht");
            }}
          >
            {BREEDTES.map((b) => (
              <option value={b} key={b} className="select-item">
                {b} cm
              </option>
            ))}
          </select>
        </Form.Group>

        {breedte.value === 100 && (
          <Form.Group as={Col} xs={6}>
            <Form.Label>Trapvorm</Form.Label>

            <select
              className="select"
              style={{ padding: "8px 4px", position: "inherit" }}
              value={trapvorm.value}
              onChange={(event: SelectChange) => {
                trapvorm.set(event.target.value as Trapvorm);
              }}
            >
              {TRAPVORMEN.map((v) => (
                <option value={v.waarde} key={v.waarde} className="select-item">
                  {v.label}
                </option>
              ))}
            </select>
            {trapvorm.value !== "recht" && (
              <Form.Text muted>
                Een deel van de profielen, treden, stootborden en het fineer
                wordt breder geleverd (120 en 140 cm).
              </Form.Text>
            )}
          </Form.Group>
        )}
      </Row>
    </div>
  );
};

export default StairsType;
